import React from "react";

import Experience from "../components/Cv/Experience";
import Education from "../components/Cv/Education";
import Courses from "../components/Cv/Courses";
import PersonalSkills from "../components/Cv/PersonalSkills";
import Awards from "../components/Cv/Awards";

export default function CV() {

    // Calculate years of experience dynamically
    const calculateYearsOfExperience = (startMonth, startYear) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11
        
        let years = currentYear - startYear;
        if (currentMonth < startMonth) {
            years -= 1;
        }
        
        return years > 0 ? years : 1; // Return at least 1 year
    };

    const softwareYears = calculateYearsOfExperience(10, 2021); // Started October 2021

    return (
        <>

            <h1 className="morePadding">Curriculum Vitae</h1>

            <div className='personalInfoDiv'>

                <img className="profileImg" src="profile2.png" alt="Samuil Borisov" />

                <div className="personalInf course1Mini">
                    <h2 className="HColor">Personal Information</h2>
                    <p><b>Name:</b> Samuil Borisov</p>
                    <p><b>Location:</b> Sofia, Bulgaria</p>
                    <p><b>Email:</b> samuil@encorp.io</p>
                    <p><b>LinkedIn:</b> <a href="https://www.linkedin.com/in/samuil-borisov-a350aa220/" target="_blank" rel="noreferrer">Profile</a></p>
                    <p><b>Git:</b> <a href="https://github.com/SamBorisov" target="_blank" rel="noreferrer">SamBorisov</a> </p>
                </div>

            </div>


            <div className="courseMiddle summarySection">
                <h2 className="HColor">Summary</h2>
                <p>
                    Software Developer with {softwareYears}+ years of professional experience. 
                    Specialized in Node.js and TypeScript for building scalable, 
                    secure backend systems and React for developing responsive SEO optimized user interfaces. 
                    Skilled in designing APIs, working with SQL and MongoDB, and deploying containerized applications with Docker or other hosting platforms. 
                    <br /><br></br>
                    Deep expertise in blockchain development with Solidity, smart contracts, decentralized applications, 
                    decentralized storage and GraphQL. 
                    <br /><br></br>
                    Adept at delivering clean, reliable, and high-quality solutions to complex problems in collaborative environments.
                    Proactive approach to understanding business logic and contributing beyond assigned tasks to ensure project success.
                    
                </p>
            </div>


            <h2>Professional Experience</h2>

            <Experience />


            <h2>Courses & Academies</h2>

            <Courses />


            <h2>Education</h2>

            <Education />


            <h2 className="morePadding">Personal Skills and Competences</h2>

            <PersonalSkills />


            <h2 className="morePadding">Awards, Honors and Certificates</h2>

            <Awards />

        </>
    )
}
